import { render } from "./DashboardListComponent.vue?vue&type=template&id=7239ea80&scoped=true"
import script from "./DashboardListComponent.vue?vue&type=script&lang=js"
export * from "./DashboardListComponent.vue?vue&type=script&lang=js"

import "./DashboardListComponent.vue?vue&type=style&index=0&id=7239ea80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7239ea80"]])

export default __exports__